export default import.meta.ROLLDOWN_FILE_URL_HH1lUX0Cz8QM4YTIy1aNrA